<qv-view-switcher
    (stateChange)="onChangeViewPerspective($event)"
    [initState]="perspective"
    [primaryButtonConfig]="primaryButtonConfig"
    [secondaryButtonConfig]="secondaryButtonConfig"
></qv-view-switcher>

